import { Page, QueryBase } from "../../../shared/models/models";

// ─── Enums ───────────────────────────────────────────────────

export enum InvitationStatusCode {
  Pending = 1,
  Accepted = 2,
  Declined = 3,
  Expired = 4,
  Cancelled = 5,
  Superseded = 6,
}

export enum RelationshipTierCode {
  Connected = 1,
  Preferred = 2,
  Contracted = 3,
}

// ─── Query Parameters ────────────────────────────────────────

export enum InvitationQueryParameter {
  createdDate = 1,
  statusCode = 2,
  inviteeEmail = 3,
}

export enum PartnershipQueryParameter {
  activatedAt = 1,
  effectiveTier = 2,
  createdDate = 3,
}

// ─── Invitation Models ───────────────────────────────────────

export interface PartnerInvitation {
  id: string;
  inviterCustomerId: string;
  inviterCustomerName: string;
  inviterCustomerLogoUrl?: string;
  inviterUserId: string;
  inviteeEmail: string;
  inviteeCustomerId?: string;
  inviteeCustomerName?: string;
  inviteeCustomerLogoUrl?: string;
  statusCode: InvitationStatusCode;
  statusName: string;
  message?: string;
  expectedCustomerType?: number;
  emailLanguage?: string;
  expiresAt: string;
  respondedAt?: string;
  createdDate: string;
  modifiedDate: string;
}

export interface CreatePartnerInvitation {
  inviteeEmail: string;
  message?: string;
  expectedCustomerType?: number;
  emailLanguage?: string;
}

export interface PartnerInvitationsQuery extends QueryBase<InvitationQueryParameter> {
  statusCode?: InvitationStatusCode;
}

// ─── Relationship Models ─────────────────────────────────────

export interface PartnerRelationship {
  id: string;
  customerIdA: string;
  customerNameA: string;
  customerLogoUrlA?: string;
  customerIdB: string;
  customerNameB: string;
  customerLogoUrlB?: string;
  tierSetByA: RelationshipTierCode;
  tierSetByB: RelationshipTierCode;
  effectiveTier: RelationshipTierCode;
  isActive: boolean;
  activatedAt: string;
  invitationId?: string;
  createdDate: string;
}

export interface PartnershipsQuery extends QueryBase<PartnershipQueryParameter> {
}

// ─── Stats ───────────────────────────────────────────────────

export interface PartnershipStats {
  totalPartnerships: number;
  connectedCount: number;
  preferredCount: number;
  contractedCount: number;
  pendingSentCount: number;
  pendingReceivedCount: number;
}

// ─── State ───────────────────────────────────────────────────

export interface CustomerPartnershipsState {
  invitationsSent: Page<PartnerInvitation> | undefined;
  invitationsReceived: Page<PartnerInvitation> | undefined;
  partnerships: Page<PartnerRelationship> | undefined;
  partnershipWith: PartnerRelationship | null | undefined;
  stats: PartnershipStats | undefined;
  selectedInvitation: PartnerInvitation | undefined;
  sentQuery: PartnerInvitationsQuery;
  receivedQuery: PartnerInvitationsQuery;
  partnershipsQuery: PartnershipsQuery;
  loading: boolean;
  actionLoading: boolean;
  error: any;
}
